import React from 'react';

class NoMatch extends React.Component {
  render() {
    return <div>404 Not Found</div>;
  }
}

export default NoMatch;
